import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Riporta la finestra in cima ad ogni cambio di rotta (evita di aprire una pagina già scrollata).
export default function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
